/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Grid, Typography } from '@mui/material'
import moment, { Moment } from 'moment'
import React from 'react'
import TimerCountdown from './components/TimerCountdown'

interface Props {
  retryMoment?: Moment
  onClickSend(): any
  onRetryReset(): any
}

interface PropsInner extends Props {}

class SendSmsAgainForm extends React.PureComponent<PropsInner> {
  render() {
    return (
      <Grid container alignItems={'center'}>
        <Typography
          css={css`
            margin-right: 7px;
          `}
        >{`Didn't receive SMS?`}</Typography>
        <div>{this.renderResend()}</div>
      </Grid>
    )
  }

  renderResend() {
    const { retryMoment } = this.props

    if (retryMoment)
      return (
        <Grid container alignItems={'center'}>
          <Typography
            css={css`
              margin-right: 5px;
            `}
          >
            Resend in
          </Typography>
          <TimerCountdown endMoment={retryMoment} onTimerEnd={this.handleTimerEnd} isZeroMinutesVisible />
        </Grid>
      )

    return (
      <Typography
        onClick={this.handlePressDidntReceive}
        css={css`
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        `}
      >
        Resend
      </Typography>
    )
  }

  handlePressDidntReceive = () => {
    this.handleStartVerification()
  }

  handleTimerEnd = () => {
    this.props.onRetryReset()
  }

  handleStartVerification = async () => {
    const { retryMoment } = this.props

    if (retryMoment) {
      const nowMoment = moment()
      if (nowMoment.isBefore(retryMoment)) {
        return null
      }
    }

    this.props.onClickSend()
  }

  componentDidMount() {
    this.handleStartVerification()
  }
}

export default SendSmsAgainForm
